import { ORIENTATION } from 'components/ToolkitV2/CardV2/Card.typed';

const CARD_PADDING = 'S8';
const CARD_ORIENTATION = ORIENTATION.HORIZONTAL;

export { CARD_PADDING, CARD_ORIENTATION };
